module.exports = __webpack_public_path__ + "static/media/heart.9db4aa41.png";